exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.fab-pos[data-v-a49b00e0] {\n  bottom: 5.5em;\n  right: 1em;\n}\n@media screen and (min-width: 80em) {\n.fab-pos[data-v-a49b00e0] {\n    bottom: 2em;\n    right: 2em;\n}\n}\n.br-pill[data-v-a49b00e0] {\n  border-radius: 9999px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-a49b00e0","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Fab.vue
// module id = 1498
// module chunks = 0